import React from 'react';
import { 
  LogoColorImg, 
  PrimaryColorGreenImg,
  PrimaryColorWhiteImg,
  AgregatorLogoImg, 
  PlatformLogoImg, 
  RoomLogoImg, 
  PammLogoImg,
  AgregatorColorImg, 
  PlatformColorImg, 
  RoomColorImg, 
  PammColorImg,
} from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
  Description 
} from '@Main/elements';
import { DownloadFile, Margin, P } from '@helpers';


export const LogoColors = ({getFileUrl, t}) => {
    return (
      <PageWrapper darkMode={true}>
        <Container paddingTop='108px' marginLeft='130px' marginRight='42px' marginBottom='185px'>
          <FlexDiv>
            <LogoColorImg/>
            <Text width='338px' marginLeft='182px' marginTop='7px' paddingBefforeText="45px">
              <h1>{t("Logo colors")}</h1>
              <p>
              {t("Two gradients are used for the primary logo, they are shown below. They are used for both the text part and the petal icon. This requirement is not subject to change.")}
              </p>
            </Text>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' marginRight='52px' marginBottom='205px'>
          <FlexDiv>
            <Text width='329px' paddingAffterText="30px" paddingBefforeText="45px">
              <h1>{t("Primary colors")}</h1>
              <p>
                {t("Note that the logo features gradients of white and green. This requirement is not subject to change.")}
              </p>
              <DownloadFile darkMode={true} fileName='primary_colors' file={getFileUrl("primary_colors")} extension='.ai'/>
            </Text>
            <Margin marginLeft='48px'>
              <PrimaryColorGreenImg/>
            </Margin>
            <Margin marginLeft='28px'>
              <PrimaryColorWhiteImg/>
            </Margin>
          </FlexDiv>
        </Container>
        <Container marginLeft='102px' marginRight='55px' paddingBottom='108px'>
          <P weight='400' size='25px' height='20px'>{t("Additional colors")}</P>
          <Text paddingAffterText="60px" paddingBefforeText="45px">
            <p>
              {t("Soft-FX product pages and product publications use brand colors for logos. This requirement is not subject to change.")}
            </p>
          </Text>
          <FlexDiv marginBottom="74px">
            <div>
              <Description>
                <AgregatorLogoImg />
                <p>{t("TickTrader Liquidity Agregator")}</p>
              </Description>
              <Description marginTop='50px'>
                <PlatformLogoImg />
                <p>{t("TickTrader Trading Platform")}</p>
              </Description>
              <Description marginTop='50px'>
                <RoomLogoImg />
                <p>{t("TickTrader Traders Room")}</p>
              </Description>
              <Description marginTop='50px'>
                <PammLogoImg />
                <p>{t("TickTrader PAMM")}</p>
              </Description>
            </div>
            <div>
              <FlexDiv>
                <Margin marginLeft='48px'>
                  <AgregatorColorImg/>
                </Margin>
                <Margin marginLeft='31px'>
                  <RoomColorImg/>
                </Margin>
              </FlexDiv>
              <FlexDiv marginTop='59px'>
                <Margin marginLeft='48px'>
                  <PlatformColorImg/>
                </Margin>
                <Margin marginLeft='31px'>
                  <PammColorImg/>
                </Margin>
              </FlexDiv>
            </div>
          </FlexDiv>
          <DownloadFile darkMode={true} fileName='additional_colors' file={getFileUrl("additional_colors")} extension='.ai'/>
        </Container>
     </PageWrapper>
  );
};
